"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _each = _interopRequireDefault(require("lodash/each"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));

var makeCall = function makeCall(_ref) {
  var event = _ref.event,
      properties = _ref.properties;

  _mixpanelBrowser.default.track(event, properties);
};
/**
 * Utilities for working with Mixpanel.
 * @module MixpanelUtils
 */


var MixpanelUtils = {
  /**
   * Identifies a user with a unique ID.
   * @static
   * @function identify
   * @param {String} uniqueId - The unique identifier.
   * @example
   * MixpanelUtils.identify(uuidV4());
   * @returns {void}
   */
  identify: function identify(uniqueId) {
    _mixpanelBrowser.default.identify(uniqueId);
  },

  /**
   * Initializes a new instance of the Mixpanel tracking object.
   * @static
   * @function init
   * @param {String} token - The Mixpanel API token.
   * @param {Object} [data={}] - Data to pass to the Mixpanel init call.
   * @param {Object} [data.config] - A dictionary of config options to override. See <a href="https://github.com/mixpanel/mixpanel-js/blob/8b2e1f7b/src/mixpanel-core.js#L87-L110">default options</a>.
   * @param {Object} [data.name] - A name for the new Mixpanel instance.
   * @example
   * MixpanelUtils.init('ABCDEFG');
   * @returns {void}
   */
  init: function init(token) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        config = _ref2.config,
        name = _ref2.name;

    _mixpanelBrowser.default.init(token, config, name);

    window.mixpanel = _mixpanelBrowser.default;
  },

  /**
   * Clears super properties and generates a new random distinct ID for this instance. Useful for clearing data when a user logs out.
   * @static
   * @function reset
   * @example
   * MixpanelUtils.reset();
   * @returns {void}
   */
  reset: function reset() {
    _mixpanelBrowser.default.reset();
  },

  /**
   * Register a set of super properties, which are included with all events.
   * @static
   * @function setSuperProps
   * @param {Object} props - An associative array of properties to store about the user.
   * @example
   * MixpanelUtils.setSuperProps({Email: 'test@livongo.com'});
   * @returns {void}
   */
  setSuperProps: function setSuperProps(props) {
    _mixpanelBrowser.default.register(props);
  },

  /**
   * Register a set of super properties only once, which are included with all events.
   * @static
   * @function setSuperPropsOnce
   * @param {Object} props - An associative array of properties to store about the user.
   * @example
   * MixpanelUtils.setSuperPropsOnce({Email: 'test@livongo.com'});
   * @returns {void}
   */
  setSuperPropsOnce: function setSuperPropsOnce(props) {
    _mixpanelBrowser.default.register_once(props);
  },

  /**
   * Set properties on a user record.
   * @static
   * @function setPeopleProps
   * @param {Object} props - An associative array of properties to store about the user.
   * @example
   * MixpanelUtils.setPeopleProps({'First name': 'John', Email: 'test@livongo.com'});
   * @returns {void}
   */
  setPeopleProps: function setPeopleProps(props) {
    _mixpanelBrowser.default.people.set(props);
  },

  /**
   * Set properties on a user record only once.
   * @static
   * @function setPeoplePropsOnce
   * @param {Object} props - An associative array of properties to store about the user.
   * @example
   * MixpanelUtils.setPeoplePropsOnce({'First name': 'John', Email: 'test@livongo.com'});
   * @returns {void}
   */
  setPeoplePropsOnce: function setPeoplePropsOnce(props) {
    _mixpanelBrowser.default.people.set_once(props);
  },

  /**
   * Track an event.
   * @static
   * @function track
   * @param {Array|Object} data - An array of or a single object of events to track.
   * @param {String} data.event - The name of the event.
   * @param {Object} [data.properties] - A set of properties to include with the event.
   * @example
   * MixpanelUtils.track({
   *     event: 'User Landed',
   *     properties: {
   *         'From Screen': 'Home
   *     }
   * });
   * @returns {void}
   */
  track: function track(data) {
    if ((0, _isArray.default)(data)) {
      (0, _each.default)(data, function (trackingCall) {
        makeCall(trackingCall);
      });
    } else {
      makeCall(data);
    }
  }
};
var _default = MixpanelUtils;
exports.default = _default;